import { Component } from '../jsti/core';
import Notifications from '../constants/Notifications';

export default class ChangeAfterScrollBy extends Component {
  changeAfter: HTMLElement;
  elementHeight: number;
  headerHeight: number;
  beforeScroll: string[];
  afterScroll: string[];
  scrollUntil: ?HTMLElement;
  offset: number = 0;
  fromTop: boolean = false;
  untilTop: boolean = false;

  /**
   * Initiate the component
   */
  bind(pEl: HTMLElement): void {
    super.bind(pEl);
    this.changeAfter = document.getElementByRef(this.el.dataset.scrollBy);
    this.elementHeight = this.el.offsetHeight;

    this.beforeScroll = this.el.dataset.beforeClass.split(' ');
    this.afterScroll = this.el.dataset.afterClass.split(' ');
    this.addListener(Notifications.SCROLL, this.onScroll);

    if (this.el.dataset.until) {
      this.scrollUntil = document.getElementByRef(this.el.dataset.until);
    }
    if (this.el.dataset.offset) {
      this.offset = +this.el.dataset.offset || 0;
    }

    if (this.el.dataset.fromTop) {
      this.fromTop = true;
    }

    if (this.el.dataset.untilTop) {
      this.untilTop = true;
    }

    this.onScroll();
  }

  /**
   * Handle on a scroll event
   */
  onScroll(): void {
    this.headerHeight = document.querySelector('header').offsetHeight;
    if (this.fromTop) {
      this.calculateScrollByFromTop();
      return;
    }
    this.calculateScrollBy();
  }

  /**
   *
   */
  calculateScrollBy() {
    if (this.changeAfter.getBoundingClientRect().top - window.innerHeight + this.elementHeight + this.offset < 0) {
      if (this.scrollUntil) {
        if (this.scrollUntil.getBoundingClientRect().top + this.offset - window.innerHeight - this.elementHeight < 0) {
          this.addBeforeClass();
          return;
        }
      }
      this.addAfterClass();
    } else {
      this.addBeforeClass();
    }
  }

  /**
   *
   */
  calculateScrollByFromTop() {
    if (this.changeAfter.getBoundingClientRect().top + this.offset - this.headerHeight + this.elementHeight < 0) {
      if (this.scrollUntil) {
        if (this.untilTop) {
          if (this.scrollUntil.getBoundingClientRect().top + this.offset - this.headerHeight - this.elementHeight < 0) {
            this.addBeforeClass();
            return;
          }
        } else {
          if (this.scrollUntil.getBoundingClientRect().top + this.offset - window.innerHeight + this.elementHeight < 0) {
            this.addBeforeClass();
            return;
          }
        }
      }
      this.addAfterClass();
    } else {
      this.addBeforeClass();
    }
  }

  /**
   * shows the element
   */
  addBeforeClass(): void {
    this.el.classList.remove(...this.afterScroll);
    this.el.classList.add(...this.beforeScroll);
  }

  /**
   * hides the element
   */
  addAfterClass(): void {
    this.el.classList.add(...this.afterScroll);
    this.el.classList.remove(...this.beforeScroll);
  }
}
